module.exports = __webpack_public_path__ + "img/specials-multislider-mitsu.dc3a4637.png";